import logo from './logo.jpg';
import './App.css';
import Header from './Header'
function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <Header />
 
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          play with react
        </a>
      </header>
    </div>
  );
}

export default App;
